import {
  Config,
  enumsCashback,
  enumsPayment,
  subscriptionRequest,
  Translator,
  useClientCampaign,
  useFetchApi,
  useQueryParams,
  useRedirect,
} from "@itarget/shared";
import { useEffect, useMemo, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useReRegisterRedirect } from "../../hooks/useReRegisterRedirect";
import {
  auth,
  offers,
  payment,
  payment as paymentRedux,
  subscription as subscriptionRedux,
  toast,
} from "../../redux";
import { calculateOfferBusinessRules } from "./utils/offerBusinessRules";
import DetailOfferView from "./views/DetailOfferView";
import { CostCenterPersonService } from "@itarget/shared/src/services/CostCenterPerson/index";

const DetailOfferContainer = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { get } = useQueryParams();
  const defaultTab = get("defaultTab");
  const { goTo } = useRedirect();
  const [value, setValue] = useState(defaultTab ? Number(defaultTab) : 0);
  const [tabs, setTabs] = useState([]);
  const [openLogin, setOpenLogin] = useState(false);
  const [state, setState] = useState("detail");
  const [offer, setOffer] = useState();
  const [showWrongCard, setShowWrongCard] = useState(false);
  const [openModalReceipt, setOpenModalReceipt] = useState(false);
  const [dataPersonCenterCostApi, setDataPersonCenterCostApi] = useState({});
  const [detailErrorMessage, setDetailtErrorMessage] = useState();
  const [necessaryErrorMessage, setNecessaryErrorMessage] = useState();
  const [errorSubscriptionData, setErrorSubscriptionData] = useState();
  const [selectedCourse, setSelectedCourse] = useState();
  const [showQuiz, setShowQuiz] = useState();
  const [purchaseQuantity, setPurchaseQuantity] = useState(1);
  const [openAdherenceTerms, setOpenAdherenceTerms] = useState(false);
  const [currentCampaignOpened, setCurrentCampaignOpened] = useState({});

  const user = useSelector((state) => state.auth.user);
  const center_cost_id = useSelector((state) => state.auth.cc);
  const centerCost = useSelector((state) => state.setting.centerCost);
  const isAutenticated = useSelector((state) => state.auth.isAutenticated);
  const selectedLang = useSelector((state) => state.language.lang);
  const shoppingCarts = useSelector((state) => state.offers.shoppingCarts);
  const settingCommerce = useSelector((state) => state.setting.settingCommerce);
  const [totalAnnuity, setTotalAnnuity] = useState(0);
  const [total, setTotal] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubscribe, setIsLoadingSubscribe] = useState(false);

  const [alert, setAlert] = useState({ message: "", open: false });
  const userPermissions = useSelector(
    (state) => state.fidelity.userPermissions
  );

  const { registerClientCompany } = useClientCampaign();
  const { PRODUCTS_CAMPINGS } = enumsCashback;

  const translation = {
    agreeWithTerms: Translator({
      transRef:
        "translation.Aceite os termos e regras para interagir com a campanha.",
    }).props.children,
    primaryKeyRequired: Translator({
      transRef:
        "translation.Complete seus dados cadastrais para continuar com a adesão a campanha. (EMAIL ou CPF)",
    }).props.children,
  };

  const {
    data: dataPreRegistration,
    error: errorPreRegistration,
    fetchData: fetchPreRegistration,
    isLoading: isLoadingPreRegistration,
  } = useFetchApi(
    Config.baseURL + `api/${selectedLang}/pre-registration`,
    "POST"
  );

  const { data: annuities = { data: [] }, fetchData: fetchAnnuities, isLoading: isLoadingAnnuities } =
    useFetchApi(
      Config.baseURL +
      `api/${selectedLang}/subscription/${user?.data?.id}/unified-registration`
    );

  const {
    data: detailRequest,
    error: erroDetailRequest,
    fetchData: fetchDetailRequest,
    isLoading: isLoadingDetail,
  } = useFetchApi(
    Config.baseURL +
    `api/${selectedLang}/activity-payment/${id}/detailing?centro_custo_id=${center_cost_id}${user?.data ? "&pessoa_id=" + user.data.id : ""
    }`
  );

  const { data: inscricoesApi, fetchData: fetchInscricoes, isLoading: isLoadingInscricoes } = useFetchApi(
    Config.baseURL +
    `api/${selectedLang}/subscription/pending?pessoa_id=${user?.data?.id}&origem_inscricao=5`
  );

  const {
    fetchData: fetchInscricoesDueDate,
    isLoading: isLoadingInscricoesDueDate,
  } = useFetchApi(
    Config.baseURLV2 + `api/subscription/persons/due-date`,
    "PUT",
    {
      Authorization: `Bearer ${user.access_token}`,
    }
  );

  const { fetchData: fetchPersonCenterCost, isLoading: isLoadingPersonCenterCost } = useFetchApi(
    Config.baseURL +
    `api/${selectedLang}/center-cost-person?pessoa_id=${user?.data?.id}&centro_custo_id=${center_cost_id}`,
    "POST"
  );

  const { data: category, fetchData: fetchListCategory, isLoading: isLoadingCategory } = useFetchApi(
    Config.baseURL +
    `api/${selectedLang}/center-cost/${center_cost_id}/category?pessoa_id=${user?.data?.id}&visivel_mod_congresso=S`
  );

  useEffect(() => {
    setDetailtErrorMessage(erroDetailRequest);
  }, [erroDetailRequest]);

  const {
    data: categoryReceiptRequest,
    fetchData: fetchCategoryReceiptRequest,
    isLoading: isLoadingCategoryReceipt,
  } = useFetchApi(
    Config.baseURL +
    `api/${selectedLang}/center-cost-category/${user?.data?.categoria_centro_custo_id}`
  );

  const { data: dataPersonCenterCost, fetchData: fetchDataPersonCenterCost, isLoading: isLoadingDataPersonCenterCost } =
    useFetchApi(
      Config.baseURL +
      `api/${selectedLang}/center-cost-person?pessoa_id=${user?.data?.id}&centro_custo_id=${center_cost_id}`
    );

  const { data: idReceipt, fetchData: fetchIdReceipt, isLoading: isLoadingIdReceipt } = useFetchApi(
    Config.baseURL +
    `api/${selectedLang}/attachments?table=pessoas_centros_custos&tabela_id=${dataPersonCenterCostApi?.id}&tipo_documento_id[]=200`
  );

  const { data: questions, fetchData: fetchQuestions, isLoading: isLoadingQuestions } = useFetchApi(
    Config.baseURL +
    `api/${selectedLang}/question?centro_custo_id=${center_cost_id}&pessoa_id=${user?.data?.id}&destino_pergunta=17`
  );

  const { data: uniqueCategoryData, fetchData: fetchUniqueCategory, isLoading: isLoadingUniqueCategory } = useFetchApi(
    Config.baseURL +
    `api/${selectedLang}/center-cost/${center_cost_id}/unique-category?pessoa_id=${user?.data?.id}`
  );

  useEffect(() => {
    if (
      userPermissions?.cashWhoCanJoin &&
      userPermissions?.cashWhoCanJoin?.status === 2
    ) {
      setAlert({
        message: userPermissions?.cashWhoCanJoin?.message,
        open: true,
      });
    } else {
      setAlert({
        message: "",
        open: false,
      });
    }
  }, [userPermissions?.cashWhoCanJoin]);

  const pendingSubscriptions =
    inscricoesApi && inscricoesApi?.data.length > 0 ? inscricoesApi.data : [];
  const activitySubscription =
    pendingSubscriptions && offer
      ? pendingSubscriptions.find(
        (activity) => activity?.agenda_atividade_id == offer?.aga_id
      )
      : null;
  const pendingSubscriptionsIdsArray = pendingSubscriptions.map(
    (subscription) => subscription?.inscricao_uuid
  );
  const pendingAccountReceiveIdsArray = pendingSubscriptions.map(
    (subscription) => subscription?.conta_receber_id
  );

  const {
    data: subscriptionComboApi,
    fetchData: fetchComboSubscription,
    isLoading: isLoadingComboSubscription,
  } = useFetchApi(
    Config.baseURL +
    `api/${selectedLang}/subscription/combo?pessoa_id=${user.data && user.data.id
    }&inscricao_id[]=${pendingSubscriptionsIdsArray.join(
      ","
    )}&conta_receber_id[]=${pendingAccountReceiveIdsArray.join(",")}`
  );

  // Combined loading state for all critical API requests
  const isLoadingAnyRequest = useMemo(() => {
    return (
      isLoadingDetail ||
      isLoadingInscricoes ||
      isLoadingDataPersonCenterCost ||
      isLoadingQuestions ||
      isLoadingUniqueCategory ||
      isLoadingCategory ||
      isLoadingComboSubscription ||
      isLoadingCategoryReceipt ||
      isLoadingIdReceipt
    );
  }, [
    isLoadingDetail,
    isLoadingInscricoes,
    isLoadingDataPersonCenterCost,
    isLoadingQuestions,
    isLoadingUniqueCategory,
    isLoadingCategory,
    isLoadingComboSubscription,
    isLoadingCategoryReceipt,
    isLoadingIdReceipt,
  ]);

  const getFilteredAnnuities = () => {
    let filteredAnnuities = annuities?.data || [];
    filteredAnnuities = filteredAnnuities.filter(
      (annuity) => !annuity?.controle_boleto_cartao_id
    );
    const pending = inscricoesApi?.data;
    if (pending) {
      filteredAnnuities = filteredAnnuities.filter(
        (annuity) =>
          !pending.some(
            (pendingSubscription) =>
              pendingSubscription.inscricao_uuid == annuity.inscricao_id
          )
      );
    }

    return filteredAnnuities;
  };

  const filteredAnnuities = getFilteredAnnuities();

  const getActivityAmount = () => {
    const subscriptionComboApiData = subscriptionComboApi?.data
      ? subscriptionComboApi.data.find(
        (subscription) =>
          subscription.inscricao_id == activitySubscription?.inscricao_uuid
      )
      : null;
    const subscriptionComboDataAmount = subscriptionComboApiData
      ? subscriptionComboApiData.valor - subscriptionComboApiData.valor_desconto
      : 0;

    let amount = null
    if (subscriptionComboDataAmount) {
      amount = subscriptionComboDataAmount
    }
    if (!amount && activitySubscription?.cr_valor && detailRequest?.data?.detailing[0]?.qtde_parcela <= 1) {
      amount = parseFloat(activitySubscription?.cr_valor)
    }
    if (!amount && detailRequest?.data?.detailing[0]?.valor) {
      amount = detailRequest?.data?.detailing[0]?.valor
    }
    return amount;
  };

  const activityAmount = getActivityAmount();

  // Memoize fetchUniqueCategory to prevent unnecessary re-renders and duplicate calls
  const memoizedFetchUniqueCategory = useCallback(() => {
    fetchUniqueCategory();
  }, [fetchUniqueCategory]);

  useEffect(() => {
    if (user?.data?.id > 0) {
      memoizedFetchUniqueCategory();
      fetchDataPersonCenterCost();
      fetchQuestions();
      fetchInscricoesDueDate({ origin: "offers" });
      fetchInscricoes();
      filteredAnnuities.length > 0 && fetchComboSubscription();
    }
  }, [
    user?.data?.id, // Only depend on user ID, not the entire user object
    fetchDataPersonCenterCost,
    fetchInscricoes,
    fetchInscricoesDueDate,
    fetchComboSubscription,
    JSON.stringify(filteredAnnuities),
    memoizedFetchUniqueCategory,
  ]);

  // useEffect para monitorar uniqueCategoryData e chamar fetchDataPersonCenterCost quando terminar
  useEffect(() => {
    if (uniqueCategoryData) {
      fetchDataPersonCenterCost();
    }
  }, [uniqueCategoryData, fetchDataPersonCenterCost]);

  // Separate useEffect for fetchCategoryReceiptRequest that depends on dataPersonCenterCostApi
  useEffect(() => {
    if (dataPersonCenterCostApi?.categoria_centro_custo_id) {
      fetchCategoryReceiptRequest();
    }
  }, [dataPersonCenterCostApi?.categoria_centro_custo_id, fetchCategoryReceiptRequest]);
  useEffect(() => {
    if (dataPersonCenterCost && user?.data?.id && user?.access_token) {
      const centerCostData = dataPersonCenterCost.data[0];
      setDataPersonCenterCostApi(centerCostData);

      // Update user.data.categoria_centro_custo_id if it's missing or different
      if (centerCostData?.categoria_centro_custo_id &&
        user?.data?.categoria_centro_custo_id !== centerCostData.categoria_centro_custo_id) {
        dispatch(
          auth.actions.updateUser({
            ...user,
            data: {
              ...user.data,
              categoria_centro_custo_id: centerCostData.categoria_centro_custo_id,
            },
          })
        );
      }
    }
  }, [dataPersonCenterCost, user, dispatch]);

  useEffect(() => {
    if (dataPersonCenterCostApi?.id) {
      fetchIdReceipt();
    }
  }, [dataPersonCenterCostApi, openModalReceipt, fetchIdReceipt]);

  const onInvalidSubscription = (errorMessage) => {
    const messageId = "invalid-subscription-message-detail-offers";
    setNecessaryErrorMessage(errorMessage);
    dispatch(toast.actions.unqueue(messageId));
    dispatch(
      toast.actions.enqueue({
        content: errorMessage,
        severity: "error",
        duration: "9000",
        id: messageId,
      })
    );
    setTotalAnnuity(0);
    if (!shoppingCarts) return;
    const returnToLastValue = shoppingCarts.length - 1;
    dispatch(
      offers.actions.setShoppingCarts(
        !returnToLastValue ? null : Array.from({ length: returnToLastValue })
      )
    );
  };

  const redirectSubscribe = async (state) => {
    const canProceed = await validCategoryReceipt();
    if (!canProceed) {
      return;
    }
    if (!user.data) {
      setOpenLogin(true);
      return;
    }
    if (
      questions?.data &&
      questions.data.length > 0 &&
      !questions.data[0].respondido
    ) {
      setShowQuiz(true);
      return;
    }

    const cloneSelectedCourse = structuredClone(selectedCourse);

    if (state !== 'inPaymentWithAnnuity') {
      cloneSelectedCourse['ids_anuidades'] = '';
      cloneSelectedCourse['plp_pacote_id'] = '';
      cloneSelectedCourse['pacote_id'] = '';
    }
    cloneSelectedCourse['qtds_inscricoes'] = purchaseQuantity;

    setIsLoadingSubscribe(true);

    try {
      await onSubscribe(cloneSelectedCourse);

      setState(state);
      if (state !== 'toCourtesy') setState('redirectToShoppingCart');
    } catch (error) {
    } finally {
      setIsLoadingSubscribe(false);
      fetchDetailRequest();
    }
  };

  const addWaitingList = async () => {
    const activity = detailRequest?.data?.detailing[0];
    if (!activity) return;
    if (!user.data) {
      setOpenLogin(true);
      return;
    }
    const payload = JSON.stringify({
      pessoa_id: user?.data?.id,
      agenda_atividade_id: activity?.aga_id,
      status: "1",
    });
    await fetchPreRegistration(payload);
  };

  useEffect(() => {
    const displayToast = (content, severity) => {
      dispatch(
        toast.actions.enqueue({
          content,
          severity,
        })
      );
    };

    if (dataPreRegistration && !errorPreRegistration) {
      displayToast(dataPreRegistration.message, "success");
    }

    if (errorPreRegistration) {
      displayToast(errorPreRegistration, "error");
    }
  }, [dataPreRegistration, errorPreRegistration]);

  const { onSubscribe, subscription, errorResponseRequest } =
    subscriptionRequest({
      user,
      selectedCourse: selectedCourse,
      onInvalid: onInvalidSubscription,
      subscriptionRedux: subscriptionRedux,
      toast: toast,
    });

  useEffect(() => {
    setErrorSubscriptionData(
      errorResponseRequest?.data || errorResponseRequest?.message
    );
  }, [errorResponseRequest]);

  useEffect(() => {
    if (isAutenticated) {
      handleCloseLogin();
    }
  }, [isAutenticated]);

  useEffect(() => {
    fetchDetailRequest();
  }, [id, fetchDetailRequest]);

  useEffect(() => {
    if (detailRequest) {
      setTabs(detailRequest.data);
      setOffer(detailRequest.data.detailing[0]);
      setSelectedCourse(detailRequest.data.detailing[0]);
    }
  }, [detailRequest]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (user?.data?.id) {
      fetchAnnuities();
    }
  }, [user?.data?.id, fetchAnnuities]);

  useEffect(() => {
    if (subscription && state === "redirectToShoppingCart") {
      goTo("shopping-cart");
    }
  }, [subscription, state, goTo]);

  const addShoppingCart = async ({
    includeAnnuitiesIds = false,
    state = '',
  }) => {
    let totalItems = 0;
    const cloneSelectedCourse = structuredClone(selectedCourse);
    if (
      !includeAnnuitiesIds &&
      Object.hasOwn(cloneSelectedCourse, 'ids_anuidades')
    )
      cloneSelectedCourse['ids_anuidades'] = null;
    const totalAnnuities = Object.is(cloneSelectedCourse['ids_anuidades'], null)
      ? 0
      : cloneSelectedCourse['ids_anuidades'].split(',').length;
    if (state !== 'inPaymentWithAnnuity') {
      cloneSelectedCourse['ids_anuidades'] = '';
      cloneSelectedCourse['plp_pacote_id'] = '';
      cloneSelectedCourse['pacote_id'] = '';
    }
    cloneSelectedCourse['qtds_inscricoes'] = purchaseQuantity;
    totalItems += cloneSelectedCourse['qtds_inscricoes'];
    totalItems += totalAnnuities;
    if (!user.data) {
      setOpenLogin(true);
      return;
    }

    if (questions.data.length > 0 && !questions.data[0].respondido) {
      setShowQuiz(true);
      return;
    }

    if (!(await validCategoryReceipt())) {
      return;
    }

    try {
      setIsLoading(true);
      dispatch(
        offers.actions.setShoppingCarts(
          Array.from({ length: shoppingCarts.length + totalItems })
        )
      );
      await onSubscribe(cloneSelectedCourse, true);
      setState(state);
      setTotalAnnuity(0);
      fetchDetailRequest();
    } finally {
      if (totalItems > 1) {
        fetchInscricoes();
      }
      setIsLoading(false);
    }
  };

  const handleCloseLogin = () => {
    setOpenLogin(false);
  };

  const changePayment = () => {
    setShowWrongCard(false);
  };

  const validCategoryReceipt = async () => {
    try {

      // Regra: data de expiração do comprovante
      const categoryCertificateStatus = await CostCenterPersonService.checkCategoryCertificateStatus({
        lang: 'pt-br', 
        personId: user?.data?.id, 
        costCenterId: center_cost_id, 
      })
      if(categoryCertificateStatus?.pending){
        setOpenModalReceipt(categoryCertificateStatus.pending)
        return false
      }
      
      // Se não tem categoryReceiptRequest, permite prosseguir
      if (!categoryReceiptRequest) {
        return true;
      }

      const exigeEvento = categoryReceiptRequest?.exige_comp_cat_evento;
      const exigeInsc = categoryReceiptRequest?.exige_comp_cat_evento_insc;

      // Enquanto carrega dados de comprovante/anexos, bloqueia sem abrir modal
      if (isLoadingCategoryReceipt || isLoadingIdReceipt) {
        return false;
      }

      const hasPersonCenter = !!dataPersonCenterCostApi?.id;
      const attachmentsEmpty = !Array.isArray(idReceipt?.data) || idReceipt?.data?.length === 0;
      const status = dataPersonCenterCostApi?.status_comprovante_categoria;

      // Regra: exige para EVENTO
      if (exigeEvento === "S") {
        if (hasPersonCenter && attachmentsEmpty) {
          setOpenModalReceipt(true);
          return false;
        }
      }

      // Regra: exige para INSCRIÇÃO
      if (exigeInsc === "S") {
        if (hasPersonCenter && (attachmentsEmpty || [0, 2].includes(status))) {
          setOpenModalReceipt(true);
          return false;
        }
      }

      return true;
    } catch (err) {
      // Em caso de erro, abre o modal por segurança
      setOpenModalReceipt(true);
      return false;
    }
  };

  const selectOffer = async (activity) => {
    goTo(`offers/${activity?.aga_id}/${activity.centro_custo_id_out}`);
  };
  const selectProduct = async (product) => {
    goTo(`offers/store/${product?.aga_id}/${product.centro_custo_id_out}`);
  };

  const actionStream = async (card) => {
    await dispatch(subscriptionRedux.actions.setTransmissionActivity(card));
    goTo("streaming");
  };

  const onClickMindsRadiology = () => {
    const detailing = tabs?.detailing?.[0];
    const mindsRadiologyUrl = detailing?.ins_metadata
      ? JSON.parse(detailing?.ins_metadata)?.mindsRadiologyUrl
      : "";
    window.open(mindsRadiologyUrl);
  };

  const updateTotalAnnuity = () => {
    const detailing = tabs?.detailing?.[0];
    if (!detailing) return 0;
    let courseValue = parseFloat(
      detailing?.valor_pacote ||
      detailing?.valor_socio_quite ||
      activityAmount ||
      0
    );
    courseValue = courseValue * purchaseQuantity;
    const total = [
      courseValue,
      parseFloat(detailing?.valor_anuidade_pendente),
    ].reduce((total, number) => {
      if (number) {
        return total + number;
      }
      return total;
    }, 0);

    return total;
  };

  const onChangeComboAnnuity = (checked) => {
    if (!checked) {
      setTotalAnnuity(0);
      return;
    }
    const total = updateTotalAnnuity();
    setTotalAnnuity(total);
  };

  const handlePurchaseQuantity = (quantity) => {
    setPurchaseQuantity(quantity);
  };

  useEffect(() => {
    if (!totalAnnuity) {
      setTotal(activityAmount * purchaseQuantity);
      return;
    }
    const total = updateTotalAnnuity();
    setTotalAnnuity(total);
  }, [activityAmount, purchaseQuantity, updateTotalAnnuity]);

  useReRegisterRedirect();

  useEffect(() => {
    if (
      questions &&
      questions?.data?.length > 0 &&
      !questions?.data[0]?.respondido
    ) {
      setShowQuiz(true);
    }
  }, [questions]);

  useEffect(() => {
    if (
      [undefined, null].includes(dataPersonCenterCost?.data) ||
      dataPersonCenterCost?.data?.length < 1
    ) {
      fetchListCategory();
    }
  }, [dataPersonCenterCost?.data, fetchListCategory]);

  const onChangeCategory = async (e) => {
    await fetchPersonCenterCost(
      JSON.stringify({
        pessoa_id: user?.data?.id,
        categoria_centro_custo_id: e.value,
        categoria_centro_custo_princ: "S",
        nome_cracha: user?.data?.nome,
      })
    );
    if (e.value) {
      const data = user.data;
      dispatch(
        auth.actions.updateUser({
          ...user,
          data: {
            ...data,
            categoria_centro_custo_descricao: category.data.filter(
              (res) => res.id === e.value
            )[0].descricao,
            categoria_centro_custo_id: category.data.filter(
              (res) => res.id === e.value
            )[0].id,
          },
        })
      );
      fetchDetailRequest();
    }
  };

  const handleAdherenceCampaign = async ({
    termsStatus = false,
    adherence,
    campaignId,
  }) => {
    if (!user?.data) {
      setOpenLogin(true);
      throw "user";
    }
    if (!user?.data?.cpf && !user?.data?.email) {
      dispatch(
        toast.actions.enqueue({
          content: translation.primaryKeyRequired,
          severity: "error",
          duration: "9000",
          id: "allowAdherenceCampaignTermsCheck",
        })
      );
      throw "primaryKey";
    }
    if (
      termsStatus === false &&
      adherence === PRODUCTS_CAMPINGS.PAY_WITH_CASHBACK.ALLOWED
    ) {
      dispatch(
        toast.actions.enqueue({
          content: translation.agreeWithTerms,
          severity: "error",
          duration: "9000",
          id: "allowAdherenceCampaignTermsCheck",
        })
      );
      throw "term";
    }
    const cashback = tabs?.detailing?.[0]?.cashback;
    const campaign = cashback.find(
      ({ campanha_id }) => campanha_id === campaignId
    );
    registerClientCompany({
      adherence,
      companyId: campaign?.empresa_id,
      campaignId: campaign?.campanha_id,
    });
  };

  const openCampaignTerms = ({ campaignId }) => {
    const cashback = tabs?.detailing?.[0]?.cashback;
    const campaign = cashback.find(
      ({ campanha_id }) => campanha_id === campaignId
    );
    setCurrentCampaignOpened(campaign);
    setOpenAdherenceTerms(true);
  };

  const closeCampaignTerms = () => {
    setCurrentCampaignOpened({});
    setOpenAdherenceTerms(false);
  };

  const businessRules = useMemo(() => {
    if (!detailRequest?.data?.detailing?.[0]) return null;

    const detailing = detailRequest.data.detailing[0];
    const soldOut = detailing?.vagas_limite <= detailing?.vagas_ocupadas;
    const canBuyMore =
      detailing?.qtd_inscricoes < detailing?.vagas_limite_insc_mesma_pessoa &&
      detailing?.mais_insc_mesma_pessoa === "S";
    const hasPendingAnnuities = filteredAnnuities.length > 0;
    const collectionFilteredByCampaignId = (detailing?.cashback || []).filter(
      (campaign, index, array) => {
        return (
          index ===
          array.findIndex(
            ({ campanha_id }) => campaign.campanha_id === campanha_id
          ) && !campaign.adesoes_clientes_campanhas_aceite
        );
      }
    );
    const mindsRadiologyUrl = detailing?.ins_metadata
      ? JSON.parse(detailing?.ins_metadata)?.mindsRadiologyUrl
      : "";
    const freeAccess =
      !detailing?.plp_id &&
      detailing?.status_inscricao ===
      enumsPayment.STATUS_REGISTRATION.REGISTERED;

    return calculateOfferBusinessRules({
      detailing,
      user,
      category,
      annuities: filteredAnnuities,
      totalAnnuity,
      soldOut,
      canBuyMore,
      hasPendingAnnuities,
      collectionFilteredByCampaignId,
      mindsRadiologyUrl,
      freeAccess,
      centerCost,
    });
  }, [
    detailRequest,
    user,
    category,
    filteredAnnuities,
    totalAnnuity,
    centerCost,
  ]);

  return (
    <DetailOfferView
      alert={alert}
      centerCost={centerCost}
      isLoadingScreen={isLoadingDetail || isLoadingComboSubscription}
      status_comprovante_categoria={
        dataPersonCenterCostApi?.status_comprovante_categoria
      }
      comp_recusa={dataPersonCenterCostApi?.comp_recusa}
      payment={payment}
      openModalReceipt={openModalReceipt}
      setOpenModalReceipt={setOpenModalReceipt}
      center_cost_id={center_cost_id}
      cc={center_cost_id}
      id={id}
      paymentRedux={paymentRedux}
      toast={toast}
      user={user}
      total={total}
      openLogin={openLogin}
      offer={!erroDetailRequest && offer}
      tabs={!erroDetailRequest && tabs}
      value={value}
      showWrongCard={showWrongCard}
      annuities={filteredAnnuities}
      handleCloseLogin={handleCloseLogin}
      handleChange={handleChange}
      addShoppingCart={addShoppingCart}
      setShowWrongCard={setShowWrongCard}
      changePayment={changePayment}
      fetchInscricoes={fetchInscricoes}
      redirectSubscribe={redirectSubscribe}
      addWaitingList={addWaitingList}
      selectOffer={selectOffer}
      selectProduct={selectProduct}
      goTo={goTo}
      activityAmount={activityAmount}
      detailErrorMessage={detailErrorMessage && detailErrorMessage}
      necessaryErrorMessage={necessaryErrorMessage && necessaryErrorMessage}
      setNecessaryErrorMessage={setNecessaryErrorMessage}
      errorSubscriptionData={errorSubscriptionData && errorSubscriptionData}
      isLoading={isLoading || isLoadingAnyRequest}
      isLoadingSubscribe={isLoadingSubscribe || isLoadingAnyRequest}
      showQuiz={showQuiz}
      setShowQuiz={setShowQuiz}
      fetchQuestions={fetchQuestions}
      questions={questions}
      category={category}
      onChangeCategory={onChangeCategory}
      totalAnnuity={totalAnnuity}
      actionStream={actionStream}
      onClickMindsRadiology={onClickMindsRadiology}
      onChangeComboAnnuity={onChangeComboAnnuity}
      handlePurchaseQuantity={handlePurchaseQuantity}
      openAdherenceTerms={openAdherenceTerms}
      currentCampaignOpened={currentCampaignOpened}
      openCampaignTerms={openCampaignTerms}
      closeCampaignTerms={closeCampaignTerms}
      handleAdherenceCampaign={handleAdherenceCampaign}
      businessRules={businessRules}
      settingCommerce={settingCommerce}
    />
  );
};

export default DetailOfferContainer;

